import { resolveAuthToken, clearAuthCookies } from './authToken';

function getErrorMessage(status) {
  switch (status) {
    case 400:
      return 'Please check the form and try again.';

    case 401:
      return 'Your session has been expired, please login again.';

    case 403:
      return "You're not authorised to access this.";

    case 500:
      return 'Something went wrong.';
    default:
      return 'Something went wrong.';
  }
}

const client = async (endpoint, { body, ...customConfig } = {}, clientMethod) => {
  const sendingFormData = body instanceof FormData;
  const token = resolveAuthToken();
  const headers = sendingFormData ? {} : { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `token ${token.token}`;
  }
  if (clientMethod === undefined) {
    if (body) {
      clientMethod = 'POST';
    } else {
      clientMethod = 'GET';
    }
  }
  const config = {
    method: clientMethod,
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    config.body = sendingFormData ? body : JSON.stringify(body);
  }

  let response = await window.fetch(`${process.env.REACT_APP_CORE_API_URL}/${endpoint}`, config);

  if (response.status === 401 && response.redirected) {
    response = await fetch(response.url, config);
  }

  if (response.status === 401) {
    logout();
    window.location.assign(window.location);
    return Promise.reject({ message: 'Please re-authenticate' });
  }

  if (response.ok) {
    return await response.json();
  } else {
    const responseText = await response.text();
    if (responseText === '') {
      return Promise.reject(new Error(getErrorMessage(response.status)));
    } else {
      const error = JSON.parse(responseText);
      return Promise.reject(new Error(error.detail));
    }
  }
};
function logout() {
  window.localStorage.clear();
  // Otherwise a stale new-dashboard cookie is re-read on reload and the app loops on 401.
  clearAuthCookies();
}

export { client };
